import { render, staticRenderFns } from "./MyLeaves.vue?vue&type=template&id=1f703204&scoped=true"
import script from "./MyLeaves.vue?vue&type=script&lang=js"
export * from "./MyLeaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f703204",
  null
  
)

export default component.exports